import { ReactNode } from 'react';

import {
  AudioLinesIcon,
  BrainCircuitIcon,
  Building2Icon,
  CircleUserRoundIcon,
  ClockIcon,
  CreditCardIcon,
  KeyIcon,
  LockIcon,
  MonitorSmartphoneIcon,
  PhoneIcon,
  ShieldCheckIcon,
  UserRoundIcon,
  WebhookIcon,
} from 'lucide-react';

import FileDollarIcon from '@/components/atoms/Icons/FileDollarIcon';
import { DEVELOPER_MODULES, DEVELOPERS_SETTINGS_PATHS } from '@/modules/developerTools/constants';

export const personalSettings = [
  {
    icon: <CircleUserRoundIcon size={16} />,
    title_key: 'pages.profile',
    link: '/profile/information',
    showBadge: true,
  },
  {
    icon: <MonitorSmartphoneIcon size={16} />,
    title_key: 'pages.security',
    link: '/profile/security',
  },
];

export const accountSettings = [
  { icon: <Building2Icon size={16} />, title_key: 'common.general', link: '/account/information' },
  {
    icon: <CreditCardIcon size={16} />,
    title_key: 'pages.billing_simple',
    link: '/account/billing',
  },
  { icon: <FileDollarIcon />, title_key: 'pages.invoices', link: '/account/invoices' },
  { icon: <PhoneIcon size={16} />, title_key: 'pages.usage', link: '/account/usage' },
  { icon: <LockIcon size={16} />, title_key: 'permissions.manage_access', link: '/account/manage' },
  {
    icon: <UserRoundIcon size={16} />,
    title_key: 'pages.human_agents',
    link: '/account/human-agents',
  },
  {
    icon: <ClockIcon size={16} />,
    title_key: 'pages.activity_logs',
    link: '/account/activity-logs',
  },
  {
    icon: <ShieldCheckIcon size={16} />,
    title_key: 'common.data_privacy',
    link: '/account/data-privacy',
  },
];

export interface SettingsNavItem {
  icon: ReactNode;
  title_key: string;
  link: string;
}

export const developerSettings: (SettingsNavItem & {
  module: (typeof DEVELOPER_MODULES)[number];
})[] = [
  {
    icon: <KeyIcon size={16} />,
    title_key: 'developer_tools.api_keys',
    link: DEVELOPERS_SETTINGS_PATHS.apiKeys,
    module: 'credentials',
  },
  {
    icon: <BrainCircuitIcon size={16} />,
    title_key: 'developer_tools.llms',
    link: DEVELOPERS_SETTINGS_PATHS.llms,
    module: 'language_models',
  },
  {
    icon: <AudioLinesIcon size={16} />,
    title_key: 'developer_tools.speech_models.title',
    link: DEVELOPERS_SETTINGS_PATHS.speechModels,
    module: 'speech_models',
  },
  {
    icon: <WebhookIcon size={16} />,
    title_key: 'developer_tools.plugins',
    link: DEVELOPERS_SETTINGS_PATHS.eventNotifications,
    module: 'plugins',
  },
];
